import React from 'react';
import { Box, Skeleton, Paper, useMediaQuery, useTheme } from '@mui/material';

const HeroBannerSkeleton = ({ variant = 'default' }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const paperStyles =
    variant === 'page'
      ? {
          borderRadius: 0,
          boxShadow: 'none',
        }
      : {
          borderRadius: 2,
        };

  return (
    <Paper
      sx={{
        position: 'relative',
        minHeight: isMobile ? '300px' : '400px',
        overflow: 'hidden',
        ...paperStyles,
      }}
    >
      <Skeleton
        variant="rectangular"
        width="100%"
        height="100%"
        sx={{ position: 'absolute' }}
      />
      <Box sx={{ p: isMobile ? 2 : 4, position: 'relative', zIndex: 1 }}>
        <Box
          sx={{
            display: 'flex',
            alignItems: 'center',
            mb: isMobile ? 2 : 3,
            flexDirection: isMobile ? 'column' : 'row',
            textAlign: isMobile ? 'center' : 'left',
          }}
        >
          <Skeleton
            variant="circular"
            width={isMobile ? 80 : 100}
            height={isMobile ? 80 : 100}
            sx={{ mb: isMobile ? 2 : 0, mr: isMobile ? 0 : 2 }}
          />
          <Box sx={{ flex: 1 }}>
            <Skeleton
              variant="text"
              width={isMobile ? '80%' : '60%'}
              height={isMobile ? 40 : 50}
              sx={{ fontSize: isMobile ? '1.5rem' : '2rem' }}
            />
          </Box>
        </Box>
        <Box sx={{ display: 'flex', gap: 1, mb: 2, flexWrap: 'wrap' }}>
          {[1, 2, 3].map((i) => (
            <Skeleton
              key={i}
              variant="rounded"
              width={isMobile ? 60 : 80}
              height={isMobile ? 24 : 32}
            />
          ))}
        </Box>
        <Skeleton variant="text" width="90%" height={20} />
        <Skeleton variant="text" width="70%" height={20} />
      </Box>
    </Paper>
  );
};

export default HeroBannerSkeleton;
